export default __webpack_public_path__ + "static/media/thumb_up_off.ae28c777.svg";